import {
  NewslettersSubscriptionsType,
  NewslettersType,
} from 'b2b-common/core/account/api/Newsletters.types';

export enum FIELD_NAME {
  activeSubscriber = 'activeSubscriber',
}

export type FormValuesType = NewslettersSubscriptionsType & {
  [FIELD_NAME.activeSubscriber]: boolean,
}

export interface Props {
  newslettersData: NewslettersType;
  onNewslettersUpdated: () => void;
}
